import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../ActionButton/ActionButton'
import Icon from '../Icon/Icon'

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: var(--font-weight-boldest);
  margin: 0;
  color: var(--color-primary);
  text-align: center;
`

const Description = styled.p`
  text-align: center;

  > p {
    margin: 0;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
`

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  margin: 0 auto;
  top: 1rem;
  left: 0;
  right: 0;
  border: none;
  background: rgb(255, 255, 255);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  outline: none;
  width: 100%;
  max-width: 450px;
  min-height: 200px;
  opacity: 0;
  display: flex;
  flex-direction: column;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${props =>
    props.align === 'center' &&
    css`
      ${Title} {
        text-align: center;
      }
      ${Description} {
        text-align: center;
      }
      ${Footer} {
        justify-content: center;
      }
    `}
`

const Content = styled.div`
  padding: 2.5rem;
  padding-top: 3.5rem;
  height: 100%;
  min-height: 200px;
`

const StyledActionButton = styled(ActionButton)`
  &:first-child {
    margin-right: 0.5rem;
  }
`

const StyledIcon = styled(Icon)``

const CloseButton = styled.a`
  float: right;
  margin-top: -20px;
  margin-right: -20px;
  cursor: pointer;
`

const overlay = {
  background: 'rgba(0, 0, 0, 0.75)',
  zIndex: 10020,
}

const content = {}

function DialogModal(props) {
  const {
    key,
    modalState,
    title,
    description,
    onCancel,
    onOk,
    cancelText,
    okText,
    onClose,
    wait,
    showCloseButton = false,
    hasCancel = true,
    align = 'default',
    customOverlay = {},
  } = props

  const [loading, setLoading] = React.useState(false)

  const onDialogOk = () => {
    if (wait) {
      setLoading(true)
      onOk()
        .then(() => {
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })

      return
    }

    onOk()
  }

  return (
    <StyledReactModal
      key={key}
      isOpen={modalState}
      style={{ overlay: { ...overlay, ...customOverlay }, content }}
      closeTimeoutMS={150}
      align={align}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <Content>
        {showCloseButton && (
          <CloseButton onClick={onClose}>
            <StyledIcon name="x" />
          </CloseButton>
        )}
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Footer>
          <StyledActionButton
            loading={loading}
            variant="primary"
            onClick={onDialogOk}
          >
            {okText || 'Okay'}
          </StyledActionButton>
          {!!hasCancel && (
            <StyledActionButton disabled={loading} onClick={onCancel}>
              {cancelText || 'Cancel'}
            </StyledActionButton>
          )}
        </Footer>
      </Content>
    </StyledReactModal>
  )
}

DialogModal.propTypes = {
  hasCancel: PropTypes.bool,
}

export default DialogModal
